import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';

export const asmTranslations: TranslationResources = {
  en,
};

export const asmTranslationChunksConfig: TranslationChunksConfig = {
  asm: ['asm'],
};
